/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { User } from '../../../../types/users/User';
import { PendingUser } from '../../../../types/users/PendingUser';
import { UsersTabType } from '../../../../types/users/UsersTabType';
import ButtonTab from '../../../atoms/Tabs/ButtonTab';
import UserSearchResults from './UserSearchResults';
import PendingUserSearchResults from './PendingUserSearchResults';

interface SearchResultsProps {
    hasWrite: boolean;
    users: User[];
    pendingUsers: PendingUser[];
    theme: DefaultTheme;
    toggleInvite: () => void;
    organizationId: string;
}

const UserSearchResultsMain: React.FC<SearchResultsProps> = ({
    hasWrite,
    users,
    pendingUsers,
    toggleInvite,
    theme,
    organizationId,
}: SearchResultsProps) => {
    const [tab, setTab] = useState<string>(UsersTabType.Users);

    return (
        <>
            <ButtonTabsActions>
                <ButtonTabs>
                    <ButtonTab
                        large
                        tabKey={UsersTabType.Users}
                        text={'Users'}
                        setTab={setTab}
                        currentTab={tab}
                        subLabel={users && users.length.toString()}
                    />
                    <ButtonTab
                        large
                        tabKey={UsersTabType.PendingUsers}
                        text={'Pending users'}
                        setTab={setTab}
                        currentTab={tab}
                        subLabel={pendingUsers && pendingUsers.length.toString()}
                    />
                </ButtonTabs>
            </ButtonTabsActions>
            {tab === UsersTabType.Users ? (
                <UserSearchResults hasWrite data={users} toggleInvite={toggleInvite} />
            ) : (
                <PendingUserSearchResults
                    hasWrite={hasWrite}
                    data={pendingUsers}
                    organizationId={organizationId}
                />
            )}
        </>
    );
};

export default withTheme(UserSearchResultsMain) as React.ComponentType<
    Omit<SearchResultsProps, 'theme'>
>;

const ButtonTabsActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const ButtonTabs = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
    width: fit-content;
    border-radius: 0.5rem;
    background: ${props => props.theme.colors.medium};
`;
